import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useDetailModel } from "../detailModel";
import { useAccountModel } from "./accountModel";
import { creditFlagDs } from "../../../../AccountService";


export const AccountSearchBox = () => {
    const { orgDs, beDs } = useDetailModel(model => [model.orgDs, model.beDs]);
    const {
        searchParam,
        updateSearchParam,
        onReset,
        onSearch,
        loadData
    } = useAccountModel(model => [model.searchParam]);

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [

        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "实体",
            fieldName: "beCode",
            size: "small",
            disabled: false,
            options: beDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "授信类型",
            fieldName: "creditFlag",
            size: "small",
            disabled: false,
            options: creditFlagDs(),
            ...searchProp
        },

        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账户名称",
            fieldName: "name",
            size: "small",
            disabled: false,
            ...searchProp
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "编码",
        //     fieldName: "code",
        //     size: "small",
        //     disabled: false,
        //     ...searchProp
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: [{ label: "已启用", value: "0" }, { label: "已禁用", value: "9" }],
            ...searchProp
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset,
        },

    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
